import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { getContactPerson, } from '@debbie/common/dist/customers/index.js';
import { Entity, phoneToString, } from '@debbie/common/dist/index.js';
import { IntentType } from '@debbie/common/dist/intents/index.js';
import { getLocale } from '@debbie/common/dist/phone/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { toEditorMentions } from '@debbie/common/dist/templates/suggestions.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useNewInteraction } from '@debbie/cortex/dist/newInteractions/index.js';
import { smsInitialState } from '@debbie/cortex/dist/newInteractions/types.js';
import { useMentionSuggestions } from '@debbie/cortex/dist/templates/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { PARSE_RESULT_TYPE, parseText } from '../../utils/templates.js';
import { Badge, Intent } from '..//index.js';
import NewEditor from '../editor/Editor.js';
import { isEditorEmpty, useEditorState } from '../editor/hooks.js';
import InteractionFooter, { AddIntentAction, SendButton, } from './InteractionFooter.js';
import TemplateSearch from './TemplateSearch.js';
import VisibilityToggle from './VisibilityToggle.js';
const SMSInteraction = (props) => {
    const singleCase = props.case;
    const { creditorId } = props.case;
    const [interaction, setInteraction] = useNewInteraction(singleCase.caseId);
    const sms = interaction.sms;
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const creditorLoadable = useCreditor(creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const collectorLoadable = useCollector((props.case &&
        creditor &&
        getCollectorOnCase(props.case.type, props.case.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const [visibleToClients, setVisibleToClients] = useState(true);
    const contentState = useEditorState(sms.content);
    const contactPerson = getContactPerson(props.customer, props.case);
    const mentionSuggestions = useMentionSuggestions(TemplateType.SMS, props.case?.caseGroup?.id || null);
    const sendSMSMutation = useMutation(async () => {
        if (!collector) {
            throw new Error('Could not find collector');
        }
        await c.newInteractions.sendSMS(singleCase.caseId, Entity.Case, sms, {
            from: collector.nickname,
            countryCode: (contactPerson &&
                contactPerson.details.phone &&
                contactPerson.details.phone.locale) ||
                (tenant != null
                    ? getLocale(tenant.countryCode, contactPerson?.details.phone?.number)
                    : '45'),
            number: contactPerson &&
                contactPerson.details.phone &&
                contactPerson.details.phone.number,
            text: parseText(contentState.html, mentionSuggestions, PARSE_RESULT_TYPE.TEXT),
        }, visibleToClients ? 'client' : 'caseworker', sms.intent);
        // TODO: initialState
        contentState.overwriteEditorContent(smsInitialState.content);
    });
    const sendSMS = () => {
        sendSMSMutation.mutate();
    };
    const phoneValidation = contactPerson &&
        contactPerson.details.phoneValidations &&
        contactPerson.details.phoneValidations.find((pV) => (pV.phone && pV.phone.number) ==
            (contactPerson.details.phone && contactPerson.details.phone.number) &&
            (pV.phone && pV.phone.locale) ==
                (contactPerson.details.phone && contactPerson.details.phone.locale));
    return (React.createElement(React.Fragment, null,
        React.createElement(TemplateSearch, { interaction: sms, templateType: TemplateType.SMS, case: singleCase, customer: props.customer, onChange: (state) => {
                contentState.overwriteEditorContent(state);
            } }),
        React.createElement("div", null,
            []
                .concat(phoneValidation &&
                phoneValidation.originalCarrier &&
                phoneValidation.originalCarrier.name
                ? {
                    content: phoneValidation.originalCarrier.name,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.originalCarrier &&
                phoneValidation.originalCarrier.networkType
                ? {
                    content: 
                    // @ts-ignore
                    lang.phoneValidation[phoneValidation.originalCarrier.networkType] || phoneValidation.originalCarrier.networkType,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.roaming &&
                phoneValidation.roaming.status &&
                phoneValidation.roaming.status != 'not_roaming'
                ? {
                    content: 
                    // @ts-ignore
                    lang.phoneValidation[phoneValidation.roaming.status] ||
                        phoneValidation.roaming.status,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.reachable &&
                !['reachable', 'unknown'].includes(phoneValidation.reachable)
                ? {
                    content: phoneValidation.reachable,
                }
                : [])
                .map((tag) => (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, style: { marginRight: '5px' } }, tag.content))),
            React.createElement("p", null, contactPerson?.details?.phone?.number &&
                phoneToString(contactPerson.details.phone))),
        React.createElement(NewEditor, { hideControls: true, mentions: toEditorMentions(mentionSuggestions), mentionSuggestions: mentionSuggestions, onChange: (html) => {
                contentState.onChange(html);
                setInteraction('sms', { ...sms, content: html });
            }, initialContent: contentState.editorContent }),
        props.isDebtor && sms.intent.type !== IntentType.Unknown && (React.createElement("div", { style: { margin: '1em 0 0 0' } },
            React.createElement(Intent, { intent: sms.intent, editable: true, onEdit: (intent) => {
                    setInteraction('sms', { ...sms, intent: intent });
                } }))),
        React.createElement(InteractionFooter, { error: sendSMSMutation.error, primary: React.createElement(SendButton, { loading: sms.loading || sendSMSMutation.isLoading, disabled: isEditorEmpty(contentState.html), onClick: sendSMS }, lang.interactions.send), actions: React.createElement(React.Fragment, null,
                props.isDebtor && sms.intent.type === IntentType.Unknown && (React.createElement(AddIntentAction, { onAdd: (intent) => setInteraction('sms', { ...sms, intent }) })),
                React.createElement(VisibilityToggle, { visible: visibleToClients, onChange: setVisibleToClients })) })));
};
export default SMSInteraction;
const StyledEditor = styled.div `
  .rdw-editor-wrapper .rdw-editor-main {
    border-top: 1px solid #ccc !important;
    border-top-left-radius: 3px !important;
    border-top-right-radius: 3px !important;
  }
`;
//# sourceMappingURL=SMSInteraction.js.map